import { getReferrerVertical, handleVerticalBackUrl } from 'lib/verticalReferrer'

const useVerticalBackUrl = () => {
    const referrer = handleVerticalBackUrl()
    return getReferrerVertical(referrer)
}

export default useVerticalBackUrl
